import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./assets/Context/AuthContext";
import "./index.css";

// Suprime el error de ResizeObserver que aparece al cambiar zoom
// Es inofensivo — el navegador solo no pudo entregar notificaciones en un frame
window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

const root = createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
